import randomstring from 'randomstring';

export const generateRandomPassword = () => {
  const password = randomstring.generate(10);
  return password;
};
